import { IndicatorActionTypes } from './indicator.types';
import api from '../../services/http';


export const selectRoomIndicators = (state) => state.indicators.roomsIndicators;
export const selectUserIndicators = (state) => state.indicators.usersIndicators;
export const selectTicketIndicators = (state) => state.indicators.ticketsIndicators;
export const selectTicketUserIndicators = (state) => state.indicators.ticketsUsersIndicators;
export const selectTeamIndicators = (state) => state.indicators.teamIndicators;

// Action creators for geting room indicators
export const setRoomsIndicatorsSuccess = (indicators) => ({
  type: IndicatorActionTypes.FETCH_ROOMS_INDICATORS,
  payload: indicators,
});

export const getRoomsIndicators = (dateRange, formatDate) => async (dispatch) => {
  try {
    const response = await api.get(`/indicators/rooms/${dateRange}`);
    const data = response.data;
    if (formatDate) {
      const formattedData = {
        ...data,
        roomsAvgTime: data.roomsAvgTime === '00:00:00' ? '0m 0s' : formatTime(data.roomsAvgTime),
        roomsQueueAvgTime: data.roomsQueueAvgTime === '00:00:00' ? '0m 0s' : formatTime(data.roomsQueueAvgTime),
        roomsTotalTime: data.roomsTotalTime === '00:00:00' ? '0m 0s' : formatTime(data.roomsTotalTime),
      };
      dispatch(setRoomsIndicatorsSuccess(formattedData));
    } else {
      dispatch(setRoomsIndicatorsSuccess(data));
    }
  } catch (error) {
    if (error.response && (error.response.data.errorMessage === 'Token Error' || error.response.status === 401)) {
      console.log('Token Error');
    }
  }
};

const formatTime = (timeString) => {
  const parts = timeString.split(':');
  const hours = parseInt(parts[0], 10);
  const minutes = parseInt(parts[1], 10);
  const seconds = parseInt(parts[2], 10);

  let formatted = '';

  if (hours > 0) {
    formatted += `${hours} ${hours === 1 ? 'hora' : 'horas'} `;
  }

  if (hours > 0 || minutes > 0) {
    formatted += `${minutes} ${minutes === 1 ? 'minuto' : 'minutos'} `;
  }

  if (hours > 0 || minutes > 0 || seconds > 0) {
    formatted += `${seconds} ${seconds === 1 ? 'segundo' : 'segundos'}`;
  }

  return formatted.trim();
};

// Action creators for geting user indicators
export const setUsersIndicatorsSuccess = (indicators) => ({
  type: IndicatorActionTypes.FETCH_USERS_INDICATORS,
  payload: indicators,
});

export const getUsersIndicators = () => {
  return async (dispatch) => {
    try {
      const response = await api.get(`/indicators/users`);
      dispatch(setUsersIndicatorsSuccess(response.data));
    } catch (error) {
      console.log(error.message);
    }
  };
};

// Action creators for geting ticket indicators
export const setTicketsIndicatorsSuccess = (indicators) => ({
  type: IndicatorActionTypes.FETCH_TICKETS_INDICATORS,
  payload: indicators,
});

export const setTicketUserIndicatorsSuccess = (indicators) => ({
  type: IndicatorActionTypes.FETCH_TICKETS_USERS_INDICATORS,
  payload: indicators,
});

export const getTicketsUserIndicators = (userId) => {
  return async (dispatch) => {
    try {
      const response = await api.get(`/indicators/tickets/${userId}`);
      dispatch(setTicketUserIndicatorsSuccess(response.data));
    } catch (error) {
      console.log(error.message);
    }
  };
};

export const getTicketsIndicators = () => {
  return async (dispatch) => {
    try {
      const response = await api.get(`/indicators/tickets`);
      dispatch(setTicketsIndicatorsSuccess(response.data));
    } catch (error) {
      console.log(error.message);
    }
  };
}

export const setTeamIndicatorsSuccess = (indicators) => ({
  type: IndicatorActionTypes.FETCH_TEAM_INDICATORS,
  payload: indicators,
});

export const getTeamIndicators = (serviceGroupId) => {
  return async (dispatch) => {
    try {
      const response = await api.get(`/indicators/team-tickets/${serviceGroupId}`);
      dispatch(setTeamIndicatorsSuccess(response.data));
    } catch (error) {
      console.log(error.message);
    }
  };
}